/**
 * The development-goal category vocabulary's DISPLAY LABEL — issue #764
 * review round 1, F4. Shared by `pages/DevelopmentPlan.jsx` (the list
 * page's own `CATEGORIES`, which layers an icon and a colour on top of
 * this for its badges) and `components/PlanMilestonesScreen.jsx` (the
 * read step, which needs only the label). Before this fix each file kept
 * its own copy of the same eight-key enum (a third, key-only copy lives in
 * `AssignGoalDialog.jsx`, in a different display order for its own
 * `<Select>` — left alone here rather than reordered to match, since
 * nothing asked for that visible change and nothing pins the order).
 *
 * Values are Title Case, matching the list page's own drawn badges
 * (`Badge` in `DevelopmentPlan.jsx`'s `GoalCard`) — the READ step's drawn
 * casing differs for two OTHER fields (Horizon, Status: "Short term", "In
 * progress"), not this one, and stays local to `PlanMilestonesScreen.jsx`.
 */
export const GOAL_CATEGORY_LABELS = {
  technical: "Technical",
  tactical: "Tactical",
  physical: "Physical",
  mental: "Mental",
  general: "General",
  batting: "Batting",
  bowling: "Bowling",
  fielding: "Fielding",
};
